import { format } from 'date-fns';
import ListActions from '../../../components/list-actions/list-actions.componenet';
import ListTableMainCell from '../../../components/list-table-main-cell/list-table-main-cell.component';
import TableCellStatus from '../../../components/table-cell-status/table-cell-status.component';
import { useMediaQuery } from 'react-responsive';

import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../../utils/column-values.util';

const ENDPOINT = "/workorders";

export const WORK_ORDERS_COLUMNS = [
    {
        Header: "MO Number",
        accessor: "workOrderNumber",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        },
        Cell: ({ value, row }) => {
            const uuid = row.original.uuid;
            return (
                <ListTableMainCell
                    value={value}
                    uuid={uuid}
                />
            )
        }
    },
    {
        Header: "Status",
        accessor: "workOrderStatus",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });
            const isRightAligned = true;

            if (!value) {
                return displayCellValue(value);
            }
            return (
                <div className={isMobileView && isRightAligned ?
                    'list-table__body__row__cell--right-aligned-mobile-cell' : ''}>
                    <TableCellStatus
                        value={value}
                    />
                </div>
            )
        }
    },
    {
        Header: "Order Date",
        accessor: "workOrderDate",
        Cell: ({ value }) => (
            format(new Date(value), 'dd/MM/yyyy')
        )
    },
    {
        Header: "Branch",
        accessor: "locationCode",
        Cell: ({ value }) => {
            return displayCellValue(value);
        }
    },
    {
        Header: "Finish Date",
        accessor: "finishDate",
        Cell: ({ value }) => (
            format(new Date(value), 'dd/MM/yyyy')
        )
    },
    {
        Header: "Approval",
        accessor: "approvalStatus",
        Cell: ({ value }) => {
            if (!value) {
                return displayCellValue(value);
            }
            return (
                <TableCellStatus
                    value={value}
                />
            )
        }
    },
]